var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 48,
    viewBox: "0 0 71 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.57 0.680054H27.44V15.0001L2.44 2.50005C1.27847 3.62212 0.567165 5.13008 0.440004 6.74005L19.64 16.3401H12.64L0.410004 10.2301V12.0001L9.14 16.3601H0.410004V19.4901H30.6L30.57 0.680054Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.23 45.8901C69.4249 44.7994 70.1791 43.3089 70.35 41.7001L50.93 32.0001H57.93L70.39 38.2301V36.4801L61.39 32.0001H70.39V28.8701H40V47.6601H43.13V33.3401L68.23 45.8901Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1 0.680054H40V19.4701H70.42V16.3401H61.42L70.42 11.8601V7.29005C70.42 7.06005 70.42 6.84005 70.42 6.62005L50.99 16.3301H43.99L69.36 3.64005C69.0767 3.19182 68.741 2.77891 68.36 2.41005L43.1 15.0001V0.680054Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.390015 28.86V32H9.12001L0.390015 36.36V41C0.390015 41.2 0.390015 41.39 0.390015 41.59L19.59 31.99H26.59L1.41001 44.58C1.69254 45.0319 2.02827 45.4482 2.41001 45.82L27.41 33.33V47.65H30.54V28.86H0.390015Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.39 28.8601V19.4701H39.97V0.680054H30.57V19.4701H0.390015V28.8601H30.57V47.6501H39.97V28.8601H70.39Z",
    fill: "#CF142B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.61 16.3401L0.410004 6.74005C0.410004 6.92005 0.410004 7.11005 0.410004 7.29005V10.2201L12.64 16.3301L19.61 16.3401Z",
    fill: "#CF142B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.93 16.3401L70.36 6.63007C70.2566 5.55859 69.8927 4.52866 69.3 3.63007L43.93 16.3201L50.93 16.3401Z",
    fill: "#CF142B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.93 32.0001L70.35 41.7101C70.3622 41.4769 70.3622 41.2432 70.35 41.0101V38.2301L57.93 32.0001H50.93Z",
    fill: "#CF142B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.61 32.0001L0.410004 41.6001C0.495306 42.6663 0.838489 43.6959 1.41 44.6001L26.62 32.0001H19.61Z",
    fill: "#CF142B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1 15.0001L68.26 2.42005C67.2042 1.43647 65.8556 0.825376 64.42 0.680054H43.1V15.0001Z",
    fill: "#00247D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M70.39 36.4701V31.9901H61.43L70.39 36.4701Z",
    fill: "#00247D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.39 16.34V11.86L61.43 16.34H70.39Z",
    fill: "#00247D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.46002 45.82C3.69091 46.9957 5.32789 47.6512 7.03002 47.65H27.44V33.33L2.46002 45.82Z",
    fill: "#00247D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1 33.33V47.65H63.75C65.4101 47.65 67.0094 47.0253 68.23 45.9L43.1 33.33Z",
    fill: "#00247D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.44 0.680054H6.36C4.88631 0.830337 3.50582 1.47128 2.44 2.50005L27.44 15.0001V0.680054Z",
    fill: "#00247D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0.390015 31.9901V36.35L9.11001 31.9901H0.390015Z",
    fill: "#00247D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0.390015 11.9701V16.3401H9.11001L0.390015 11.9701Z",
    fill: "#00247D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/UK.1073928d30ab2d6c69537fb4dd7a2435.svg";
export { ForwardRef as ReactComponent };